import script from "./DownloadResources.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadResources.vue?vue&type=script&setup=true&lang=js"

import "./DownloadResources.vue?vue&type=style&index=0&id=607f1b65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607f1b65"]])

export default __exports__